/* ============================================================================
   Feevra — lyd paa produktvideoer
   ----------------------------------------------------------------------------
   Browsere afviser afspilning med lyd, indtil brugeren har roert siden, og
   scroll taeller ikke. Vi forsoeger derfor ikke at snige lyden ind — videoen
   koerer lydloest, og en tydelig knap slaar lyden til.

     1. Videoen spiller lydloest naar den er i view, pauser naar den er ude.
     2. Knappen oeverst til hoejre slaar lyden til og fra. Naar den er lydloes,
        staar der "Lyd" ved siden af ikonet, saa det er til at faa oeje paa.
     3. Valget huskes i sessionStorage resten af besoeget og gaelder alle
        videoer, saa man ikke skal trykke igen ved hvert produkt.
     4. Browserens eget lyd-ikon i kontrolbjaelken skjules, saa der kun er ét
        sted at styre lyden.
   ========================================================================== */
(function () {
  'use strict';

  var STORE_KEY = 'feevra:video-sound'; // 'on' | 'off'
  // Feevra bruger sit eget produktgalleri (.fv-gal__*), ikke temaets
  // .product-media. Begge er med, saa scriptet ogsaa virker hvis galleriet
  // skiftes tilbage til standard.
  var SELECTOR = '[class*="fv-gal"] video, .product-media video';
  var VISIBLE = 0.35; // hvor meget af videoen der skal vaere i view

  var active = null;

  /* --- praeference ------------------------------------------------------- */

  function soundWanted() {
    try {
      return sessionStorage.getItem(STORE_KEY) === 'on';
    } catch (e) {
      return false; // default: lydloes
    }
  }

  function rememberSound(on) {
    try {
      sessionStorage.setItem(STORE_KEY, on ? 'on' : 'off');
    } catch (e) {
      /* ignoreres bevidst */
    }
  }

  /* --- ikoner ------------------------------------------------------------ */

  var ICON_ON =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9v6h4l5 4V5L7 9H3zm13.5 3a4.5 4.5 0 0 0-2.5-4v8a4.5 4.5 0 0 0 2.5-4zM14 3.2v2.1a6.8 6.8 0 0 1 0 13.4v2.1a8.9 8.9 0 0 0 0-17.6z"/></svg>';
  var ICON_OFF =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9v6h4l5 4V5L7 9H3zm18.5-.9-1.4-1.4L17 9.8l-3.1-3.1v2.8l1.7 1.7-1.7 1.7v2.8l3.1-3.1 3.1 3.1 1.4-1.4-3.1-3.1 3.1-3.1z"/></svg>';

  /* --- styling ----------------------------------------------------------- */

  function injectStyles() {
    if (document.getElementById('feevra-video-sound-styles')) return;
    var s = document.createElement('style');
    s.id = 'feevra-video-sound-styles';
    s.textContent =
      '.feevra-sound-btn{position:absolute;right:12px;bottom:12px;z-index:6;' +
      'height:42px;padding:0 14px;border:0;border-radius:21px;cursor:pointer;' +
      'display:inline-flex;align-items:center;gap:7px;' +
      'font:600 14px/1 Instrument Sans,system-ui,sans-serif;' +
      'background:rgba(20, 18, 16,.72);color:#fff;' +
      '-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);' +
      'box-shadow:0 2px 10px rgba(0,0,0,.18);' +
      'transition:background .15s ease,transform .15s ease}' +
      '.feevra-sound-btn[aria-pressed="true"]{padding:0;width:42px;justify-content:center}' +
      '.feevra-sound-btn:hover{background:rgba(20, 18, 16,.92)}' +
      '.feevra-sound-btn:active{transform:scale(.94)}' +
      '.feevra-sound-btn:focus-visible{outline:2px solid #141210;outline-offset:2px}' +
      '.feevra-sound-btn svg{width:20px;height:20px;display:block;flex:0 0 auto;fill:currentColor}' +
      '@media (prefers-reduced-motion:reduce){.feevra-sound-btn{transition:none}}' +
      /* Vi fjerner controls-attributten i attach(), saa der kun er ét lyd-ikon.
         Disse regler er en ekstra sikring hvis temaet skulle saette den igen —
         iOS Safari respekterer dem dog ikke, derfor er attributten det
         primaere greb. */
      '[class*="fv-gal"] video::-webkit-media-controls,' +
      '[class*="fv-gal"] video::-webkit-media-controls-enclosure,' +
      '.product-media video::-webkit-media-controls,' +
      '.product-media video::-webkit-media-controls-enclosure' +
      '{display:none!important;-webkit-appearance:none!important}';
    document.head.appendChild(s);
  }

  /* --- knap -------------------------------------------------------------- */

  var SV = /^sv/i.test(document.documentElement.lang || '');
  var T = SV ? {lbl:'Ljud', on:'Stäng av ljudet', off:'Slå på ljudet'} : {lbl:'Lyd', on:'Slå lyd fra', off:'Slå lyd til'};

  function syncButton(video) {
    var btn = video.__feevraSoundBtn;
    if (!btn) return;
    var on = !video.muted;
    btn.innerHTML = on ? ICON_ON : ICON_OFF + '<span>' + T.lbl + '</span>';
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? T.on : T.off);
    btn.setAttribute('title', on ? T.on : T.off);
  }

  function addButton(video) {
    if (video.__feevraSoundBtn) return;
    var wrap =
      video.closest('.fv-gal__slide') ||
      video.closest('.product-media') ||
      video.parentElement;
    if (!wrap) return;

    if (window.getComputedStyle(wrap).position === 'static') {
      wrap.style.position = 'relative';
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'feevra-sound-btn';

    btn.addEventListener('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation(); // maa ikke ramme temaets play/pause
      var turnOn = video.muted;
      setMuted(video, !turnOn);
      if (turnOn) video.volume = 1;
      rememberSound(turnOn);
      syncButton(video);
      var p = play(video);
      if (p) p.catch(function () {});
    });

    wrap.appendChild(btn);
    video.__feevraSoundBtn = btn;
    syncButton(video);
    placeButton(video);
  }


  // Galleriet har badge-piller i toppen og en certificerings-raekke i bunden,
  // begge i fuld bredde. Knappen laegges lige over cert-raekken, og hoejden
  // maales ved runtime saa den foelger med naar layoutet skifter.
  function placeButton(video) {
    var btn = video.__feevraSoundBtn;
    if (!btn) return;
    // Kun cert-raekken i videoens EGET slide taeller. Galleriet holder alle
    // slides i DOM'en side om side, saa en cert-raekke fra et naboslide ville
    // ellers skubbe knappen op uden grund.
    var scope = btn.parentElement;
    var cert = scope && scope.querySelector('.fv-cert');
    var offset = 12;
    if (cert && cert.offsetHeight && cert.offsetParent !== null) {
      offset = cert.offsetHeight + 10;
    }
    btn.style.bottom = offset + 'px';
  }

  function placeAll() {
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), function (v) {
      if (v.__feevraSoundBtn) placeButton(v);
    });
  }

  var resizeTimer = null;
  window.addEventListener(
    'resize',
    function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(placeAll, 150);
    },
    { passive: true }
  );

  /* --- afspilning -------------------------------------------------------- */

  // Naar VI aendrer muted, saettes flaget kortvarigt, saa volumechange-lytteren
  // kan skelne vores egne aendringer fra brugerens.
  function setMuted(video, muted) {
    video.__feevraInternal = true;
    video.muted = muted;
    setTimeout(function () {
      video.__feevraInternal = false;
    }, 0);
  }

  function play(video) {
    var p;
    try {
      p = video.play();
    } catch (e) {
      return null;
    }
    return p && typeof p.catch === 'function' ? p : null;
  }

  function resume(video) {
    var p = play(video);
    if (!p) return;
    p.catch(function () {
      // Afvist — naesten altid fordi lyden var slaaet til. Fald tilbage til
      // lydloest, saa videoen aldrig staar stille.
      setMuted(video, true);
      syncButton(video);
      var q = play(video);
      if (q) q.catch(function () {});
    });
  }

  function silence(video) {
    if (!video || video.muted) return;
    setMuted(video, true);
    syncButton(video);
  }

  /* --- hvilken video er i view? ------------------------------------------ */

  var observer = null;

  function ensureObserver() {
    if (observer || typeof IntersectionObserver !== 'function') return;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= VISIBLE) {
            if (active && active !== video) silence(active);
            active = video;
            // Lyd kun hvis brugeren selv har slaaet den til tidligere i
            // besoeget — ellers lydloes afspilning.
            if (soundWanted()) {
              setMuted(video, false);
              video.volume = 1;
            } else {
              setMuted(video, true);
            }
            syncButton(video);
            resume(video);
          } else if (!entry.isIntersecting) {
            silence(video);
            try {
              video.pause();
            } catch (e) {
              /* ignoreres bevidst */
            }
            if (active === video) active = null;
          }
        });
      },
      { threshold: [0, VISIBLE] }
    );
  }

  /* --- opsaetning -------------------------------------------------------- */

  function attach(video) {
    if (video.__feevraSoundReady) return;
    video.__feevraSoundReady = true;
    video.setAttribute('playsinline', '');

    // Temaets indbyggede kontroller fjernes. iOS Safari lader sig ikke style,
    // saa dens lyd-ikon ville ellers ligge side om side med vores knap.
    video.removeAttribute('controls');
    video.controls = false;

    // Til gengaeld: tryk paa selve videoen saetter paa pause og i gang igen.
    video.addEventListener('click', function () {
      if (video.paused) {
        var p = play(video);
        if (p) p.catch(function () {});
      } else {
        try {
          video.pause();
        } catch (e) {
          /* ignoreres bevidst */
        }
      }
    });

    // Bruger de browserens eget lyd-ikon (Firefox, hvor vi ikke kan skjule
    // det), skal knappen og den huskede praeference foelge med.
    video.addEventListener('volumechange', function () {
      syncButton(video);
      if (!video.__feevraInternal) rememberSound(!video.muted);
    });

    // Produktsiden kan slå lyd-knappen fra (fx videoer uden lyd): data-fv-no-sound på galleriet
    if (!video.closest('[data-fv-no-sound]')) addButton(video);
    if (observer) observer.observe(video);
  }

  function scan() {
    var found = document.querySelectorAll(SELECTOR);
    if (!found.length) return;
    injectStyles();
    ensureObserver();
    Array.prototype.forEach.call(found, attach);
    setTimeout(placeAll, 300);
  }

  /* --- start ------------------------------------------------------------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Galleriet gentegnes ved variant-skift — fang nye videoer.
  if (typeof MutationObserver === 'function') {
    var timer = null;
    new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(scan, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
